import IconButton from 'apollo-react/components/IconButton';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import React from 'react';

const ExpandCollapseCell = ({ row: { rowId, expanded, setExpandedRow } }) => {
  return (
    <IconButton size="medium" onClick={() => setExpandedRow(expanded ? null : rowId)}>
      <ChevronRight
        style={{
          width: '0.85em',
          height: '0.85em',
          transform: `rotate(${expanded ? 90 : 0}deg)`,
        }}
      />
    </IconButton>
  );
};

export default ExpandCollapseCell;
